import type { CSSProperties } from "react";
import { tableStyles } from "../../components/DataTable";

export const s: Record<string, CSSProperties> = {
  ...tableStyles,
  msg: { fontSize: 14, color: "var(--color-text-secondary)", padding: 24 },
  card: {
    border: "1px solid var(--color-border)",
    borderRadius: 8,
    padding: 16,
    marginBottom: 20,
  },
  infoRow: { display: "flex", padding: "6px 0", gap: 12 },
  infoLabel: {
    width: 120,
    fontSize: 12,
    color: "var(--color-text-secondary)",
    fontWeight: 500,
  },
  infoValue: { fontSize: 13 },
  badge: {
    display: "inline-block",
    padding: "2px 8px",
    borderRadius: 10,
    fontSize: 11,
    fontWeight: 600,
  },
  dangerBtn: {
    padding: "8px 16px",
    fontSize: 13,
    fontWeight: 500,
    borderRadius: 6,
    background: "var(--color-danger)",
    color: "#fff",
  },
  primaryBtn: {
    padding: "8px 16px",
    fontSize: 13,
    fontWeight: 500,
    borderRadius: 6,
    background: "var(--color-primary)",
    color: "#fff",
  },
  warningBtn: {
    padding: "8px 16px",
    fontSize: 13,
    fontWeight: 500,
    borderRadius: 6,
    background: "#b45309",
    color: "#fff",
  },
  actionGroup: {
    display: "flex",
    gap: 8,
    flexWrap: "wrap",
    justifyContent: "flex-end",
  },
  bannedLabel: {
    fontSize: 13,
    color: "var(--color-text-secondary)",
    fontStyle: "italic",
  },
  statsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(160px, 1fr))",
    gap: 12,
    marginBottom: 20,
  },
  statCard: {
    display: "flex",
    flexDirection: "column",
    padding: 16,
    border: "1px solid var(--color-border)",
    borderRadius: 8,
  },
  statLabel: {
    fontSize: 12,
    color: "var(--color-text-secondary)",
    marginBottom: 4,
  },
  statValue: { fontSize: 18, fontWeight: 600 },
  tabBar: {
    display: "flex",
    gap: 0,
    borderBottom: "1px solid var(--color-border)",
    marginBottom: 16,
  },
  tab: {
    padding: "10px 16px",
    fontSize: 13,
    fontWeight: 500,
    background: "none",
    color: "var(--color-text-secondary)",
    borderBottom: "2px solid transparent",
  },
  tabActive: {
    color: "var(--color-text)",
    borderBottomColor: "var(--color-primary)",
  },
  emptyTab: { fontSize: 13, color: "var(--color-text-secondary)", padding: 16 },
  timeline: { paddingLeft: 16 },
  timelineItem: {
    display: "flex",
    gap: 12,
    paddingBottom: 16,
    position: "relative",
  },
  timelineDot: {
    width: 8,
    height: 8,
    borderRadius: "50%",
    background: "var(--color-primary)",
    marginTop: 5,
    flexShrink: 0,
  },
  timelineContent: { flex: 1 },
  timelineAction: {
    fontSize: 13,
    fontWeight: 600,
    display: "block",
  },
  timelineMeta: {
    fontSize: 12,
    color: "var(--color-text-secondary)",
    display: "block",
    marginTop: 2,
  },
  timelineReason: {
    fontSize: 12,
    color: "var(--color-text-secondary)",
    marginTop: 4,
    lineHeight: 1.5,
  },
};
